<template>
  <a-drawer
    :destroy-on-close="true"
    :title="isUpdate ? '公网 IP 编辑' : '公网 IP 创建'"
    :visible="visible"
    :width="800"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="云服务商" prop="vendor">
        <a-input v-model="form.vendor" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="云主机区域" prop="location">
        <a-input v-model="form.location" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="业务系统名称" prop="service">
        <simple-select
          v-model="form.service"
          :options="serviceOptions"
          :autoSelect="false"
          style="width: 100%"
        ></simple-select>
      </a-form-model-item>
      <a-form-model-item label="审核通过日期" prop="approvedAt">
        <a-date-picker v-model="form.approvedAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="主办单位名称" prop="organization">
        <a-input v-model="form.organization" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="主办单位性质" prop="organizationType">
        <a-input v-model="form.organizationType" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="ICP 备案/许可证号" prop="icpNumber">
        <a-input v-model="form.icpNumber" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="网站域名" prop="domain">
        <a-input v-model="form.domain" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="公网 IP" prop="ipAddress">
        <a-input v-model="form.ipAddress" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item
        :wrapper-col="{ span: 20, offset: 4 }"
        style="margin-bottom: 0"
      >
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import {
  getPublicIpInventory,
  updatePublicIpInventory,
  createPublicIpInventory, getServiceInventoryList
} from '@/api/inventory.js'
import SimpleSelect from '@/components/select/SimpleSelect.vue'

export default {
  name: 'InputDrawer',
  components: {
    SimpleSelect
  },
  data () {
    return {
      visible: false,
      isUpdate: false,
      form: {
        id: '',
        vendor: '',
        location: '',
        service: undefined,
        approvedAt: undefined,
        organization: '',
        organizationType: '',
        icpNumber: '',
        domain: '',
        ipAddress: ''
      },
      rules: {
        ipAddress: [
          {
            message: '请输入公网 IP',
            required: true,
            trigger: 'blur'
          }
        ]
      },
      loading: false,
      serviceOptions: []
    }
  },
  methods: {
    show (id) {
      this.fetchServiceList()
      if (id) {
        this.isUpdate = true
        getPublicIpInventory(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              vendor: data.vendor,
              location: data.location,
              service: data.service ? { label: data.service.name, value: data.service.id } : undefined,
              approvedAt: data.approved_at ? moment(data.approved_at, 'YYYY-MM-DD') : undefined,
              organization: data.organization,
              organizationType: data.organization_type,
              icpNumber: data.icp_number,
              domain: data.domain,
              ipAddress: data.ip_address
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer () {
      this.form = {
        id: '',
        vendor: '',
        location: '',
        service: undefined,
        approvedAt: undefined,
        organization: '',
        organizationType: '',
        icpNumber: '',
        domain: '',
        ipAddress: ''
      }
      this.serviceOptions = []
      this.isUpdate = false
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            ip_address: this.form.ipAddress
          }
          if (this.form.vendor) params.vendor = this.form.vendor
          if (this.form.location) params.location = this.form.location
          if (this.form.service) params.service_id = this.form.service.value
          if (this.form.approvedAt) params.approved_at = this.form.approvedAt.format('YYYY-MM-DD')
          if (this.form.organization) params.organization = this.form.organization
          if (this.form.organizationType) params.organization_type = this.form.organizationType
          if (this.form.icpNumber) params.icp_number = this.form.icpNumber
          if (this.form.domain) params.domain = this.form.domain
          if (this.isUpdate) {
            updatePublicIpInventory(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createPublicIpInventory(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    },
    fetchServiceList () {
      getServiceInventoryList().then(res => {
        if (res.data && res.data.total) {
          this.serviceOptions = res.data.data.map(item => {
            return {
              label: item.name,
              value: item.id
            }
          })
        }
      })
    }
  }
}
</script>
